import { Company } from './company';

export const COMPANIES: Company[]= 
[
    {ruc:'20271522950',name:'DESPENSA PERUANA S.A', logo_url:'https://cdn.digitalinka.com/img/despensa_peruana.jpeg'},
    {ruc:'20353607783',name:'MERCANTIL INCA S.A.', logo_url:'https://cdn.digitalinka.com/img/mercantil.jpeg'},
    {ruc:'20531321970',name:'ALMACENES DE LA SELVA S.A.C.', logo_url:'https://cdn.digitalinka.com/img/almacenes_selva.jpeg'},
    {ruc:'20603215088',name:'DESPENSA DE LA SELVA S.A.C.', logo_url:'https://cdn.digitalinka.com/img/despensa_selva.jpeg'},
    {ruc:'20538277721',name:'ECONOMYSA S.A.C.', logo_url:'https://cdn.digitalinka.com/img/economysa.png'},
]